import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { imageURLWithTransform } from 'frontend_core/dist/helpers/format'
import Path from 'routes/path'

function HomeRoomPriceBox({ room }) {
  if (!room.prices || room.prices.length == 0) return null
  const price = room.prices[0]
  const isDirect = room.hasDirectReservationPlans ? true : false
  const isTopHost = room.owner.rank && room.owner.rank == 1 ? true : false
  const isLastMinuteDiscount = room.hasLastMinuteDiscountPlans ? true : false
  let directReservationIcon = null
  let topHostIcon = null
  let priceIcons = null
  let lastMinuteDiscountIcon = null

  directReservationIcon = isDirect ? (
    <i className="fa fa-bolt md-top-units__item-instant" />
  ) : null
  topHostIcon = isTopHost ? (
    <span className="icon-spm-top_host md-top-units__item-top-host" />
  ) : null
  lastMinuteDiscountIcon = isLastMinuteDiscount ? (
    <i className="icon-spm-discount md-top-units__item-icon-discount" />
  ) : null

  if (directReservationIcon || topHostIcon || lastMinuteDiscountIcon) {
    priceIcons = (
      <span className="md-top-units__price-icon">
        {directReservationIcon}
        {topHostIcon}
        {lastMinuteDiscountIcon}
      </span>
    )
  }

  if (room.isInquiryOnly) {
    return (
      <p className="md-top-units__item-price">
        {room.inquiry_text}
        {priceIcons}
      </p>
    )
  }

  if (price.maxText != null) {
    if (price.minUnitText == null) {
      return (
        <p className="md-top-units__item-price">
          {price.minText}
          <span className="md-top-units__item-per">〜</span>
          {price.maxText}
          <span className="md-top-units__item-per">/{price.maxUnitText}</span>
          {priceIcons}
        </p>
      )
    } else {
      return (
        <p className="md-top-units__item-price">
          {price.minText}
          <span className="md-top-units__item-per">/{price.minUnitText}</span>
          {price.maxText}
          <span className="md-top-units__item-per">/{price.maxUnitText}</span>
          {priceIcons}
        </p>
      )
    }
  } else {
    return (
      <p className="md-top-units__item-price">
        {price.minText}
        <span className="md-top-units__item-per">/{price.minUnitText}</span>
        {priceIcons}
      </p>
    )
  }
}

export default ({ moreLink, title, footerLinkTitle, rooms, eventTypeName }) => (
  <div className="page__stripes top-page__padding">
    <div className="container top-container">
      <div className="top-title__container clearfix">
        <h2 className="top-title">{title}</h2>
        <a href={moreLink} className="pc-hide__sm-show top-more__area-link">
          すべて見る
        </a>
      </div>
      <div className="top-units__container">
        <div className="row">
          {rooms.map((room, rank) => (
            <div key={rank} className="col-xs-4">
              <a
                href={
                  eventTypeName === 'stay'
                    ? Path.stayRoom(room.id)
                    : Path.room(room.space.username, room.uid)
                }
                className="a__top-units"
              >
                <div className="md-top-units mdc-elevation--z2">
                  <div className="md-top-units__image">
                    {rank != null &&
                      rank < 3 && (
                        <div
                          className={`top-units-ranking units-ranking__no${rank +
                            1} units-ranking units-ranking__icon`}
                        >
                          <div className="units-ranking__icon-body">
                            <span className="units-ranking__icon-number">
                              {rank + 1}
                            </span>
                          </div>
                        </div>
                      )}
                    {room.thumbnails.results.length > 0 && (
                      <img
                        src={imageURLWithTransform(
                          room.thumbnails.results[0].url,
                          { width: 490, height: 490, crop: 'fill' },
                        )}
                        alt={`${room.pageTitle} の写真`}
                        className="md-top-units__image-pict"
                      />
                    )}
                    {!!room.prices && <HomeRoomPriceBox room={room} />}
                  </div>
                  <div className="md-top-units__body">
                    <div className="md-top-units__body-inner">
                      <h3 className="md-top-units__body-title">
                        {room.pageTitle}
                      </h3>
                    </div>
                    <ul className="md-top-units__body-info">
                      <li>
                        <i className="fa fa-user mr5" />
                        {room.capacity}人
                      </li>
                      <li>
                        <i className="fa fa-map-marker mr5" />
                        {room.space.stateText}
                        {room.space.city}
                      </li>
                    </ul>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
      <div className="sm-hide top-more__area">
        <a href={moreLink} className="top-more__area-link">
          {footerLinkTitle}
        </a>
      </div>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/organisms/CategoryRoomList/index.js